export default {"src":"/_next/static/media/RPRX.431a1d9d.svg","height":18,"width":18};